<template>
  <div class="tomb_page">
    <div
      class="head-topbar lite-page-top linebottom sticky"
      style="background: rgb(255, 255, 255);"
    >
      <div class="topbar-left" @click="goto('/my')"><i class="icon-arrow-left"></i></div>
      <div class="topbar-main"><h4>我关注的纪念馆</h4></div>
      <div class="topbar-right"></div>
    </div>
    <div>
      <div class="adm-pull-to-refresh">
        <div class="adm-pull-to-refresh-content">
          <div style="margin-top: 12px;" v-for="(item, index) in hallList" :key="index">
            <span
              ><div class="list-item">
                <div>
                  <div class="item-head">
                    <div class="item-head-list">
                      <div class="item-head-img">
                        <img :src="item.firstPhoto" />
                      </div>
                      <div class="item-name TextChangeToOneLines">{{ item.firstName }}</div>
                    </div>
                    <div class="item-head-list" v-if="item.hallCount.value == '2'">
                      <div class="item-head-img">
                        <img :src="item.secondPhoto" />
                      </div>
                      <div class="item-name TextChangeToOneLines">{{ item.secondName }}</div>
                    </div>
                  </div>
                  <div class="item-birth">
                    <span class="birth-item">{{ getDateFormatter(item.firstBirthDate) }}</span>
                    <span class="birth-item" v-if="item.hallCount.value == '2'">{{
                      getDateFormatter(item.secondBirthDate)
                    }}</span>
                  </div>
                </div>
                <div class="item-hot">
                  <span class="love"
                    ><i class="icon-love"></i><span>{{ item.candleCount }}</span></span
                  ><span class="view"
                    ><i class="icon-view"></i><span>{{ item.browserCount }}</span></span
                  >
                </div>
                <div>
                  <div class="bottom-line"></div>
                  <div class="bottom-flex">
                    <div class="flex-item">
                      <i class="icon icon-friends"></i
                      ><span class="icon-text">亲友团({{ item.friendCount }})</span>
                    </div>
                    <div class="flex-item">
                      <i class="icon icon-cancel"></i><span class="icon-text" @click="deleteCollect(item.id)">取消关注</span>
                    </div>
                  </div>
                </div>
              </div>
            </span>
          </div>
          <div class="adm-infinite-scroll">
            <div><span>没有更多数据了</span></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  name: 'myCreat',
  data() {
    return {
      hallList: [],
    }
  },
  methods: {
    goto(str) {
      this.$router.push({ path: str })
    },
    getDateFormatter(value) {
      if (value) {
        return moment(value, 'YYYY-MM-DD HH:mm:ss').format('YYYY年MM月DD日')
      } else {
        return ''
      }
    },
    queryCollect() {
      var that = this
      this.$queryAll(
        '/api/hallcollect/queryCollectAll',
        { myId: this.$store.getters.userId },
        function(res) {
          that.$fill(that.hallList, res['data'])
        }
      )
    },
    deleteCollect(id){
      var that = this
      this.$dialog
        .confirm({
          message: '是否取消关注？',
        })
        .then(() => {
          // on confirm
          that.$submit('/api/hallcollect/removeCollect', {hallId: id, myId: this.$store.getters.userId}, function(res) {
            if(res.code==1){
              that.$toast.success('已经是否取消关注')
              that.queryCollect()
            }
          })
        })
        .catch(() => {
          // on cancel
        })
    }
  },
  mounted() {
    this.queryCollect()
  },
  created() {},
}
</script>

<style>
.tomb_page .list-item {
  background-color: #fff;
  margin: 0 12px 12px;
  border-radius: 7.5px;
  padding: 12px;
  box-sizing: border-box;
  position: relative;
}

.tomb_page .list-item .item-flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.tomb_page .list-item .item-flex .icon-upgrade {
  width: 5.91rem;
  height: 2rem;
}

.tomb_page .list-item .item-flex .icon-upgrade img {
  width: 100%;
}

.tomb_page .list-item .item-flex .item-icon-more {
  width: 2rem;
  height: 10px;
  line-height: 5px;
  text-align: center;
  color: #333;
  font-size: 24px;
  display: inline-block;
}

.tomb_page .list-item .item-head {
  width: 100%;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  margin-top: 1.818rem;
}

.tomb_page .list-item .item-head .item-head-img {
  width: 104px;
  height: 130px;
  background-color: #fff;
  border: 3px solid #666;
  padding: 3px;
  box-sizing: border-box;
  position: relative;
  margin: 0 auto;
}

.tomb_page .list-item .item-head .item-head-img img {
  width: 100%;
  height: 100%;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 50%;
  vertical-align: top;
  -o-object-fit: cover;
  object-fit: cover;
}

.tomb_page .list-item .item-name {
  text-align: center;
  font-size: 1.454rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333;
  margin-top: 0.9rem;
  padding: 0 4rem;
  line-height: 1.3;
}

.tomb_page .list-item .item-birth {
  width: 100%;
  display: flex;
  justify-content: space-evenly;
  font-size: 1.09rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999;
  margin-top: 1rem;
  box-sizing: border-box;
}

.tomb_page .list-item .item-birth .slide-birth {
  width: 50%;
}

.tomb_page .list-item .item-birth .birth-item {
  line-height: 1.3;
  display: block;
  text-align: center;
}

.tomb_page .list-item .item-hot {
  margin-top: 1.272rem;
  display: flex;
  justify-content: space-evenly;
  box-sizing: border-box;
  font-size: 1.09rem;
  color: #666;
}

.tomb_page .list-item .item-hot .love,
.tomb_page .list-item .item-hot .view {
  display: flex;
  justify-content: center;
  align-items: center;
}

.tomb_page .list-item .item-hot .love {
  margin-right: 6.818rem;
}

.tomb_page .list-item .item-hot .love .icon-love {
  height: 20px;
  width: 20px;
  background: url('../../../assets/jnt/hot.png') no-repeat;
  position: relative;
  background-size: 100% 100%;
  margin-right: 2px;
}

.tomb_page .list-item .item-hot .view .icon-view {
  height: 20px;
  width: 20px;
  background: url('../../../assets/jnt/view.png') no-repeat;
  background-size: 100% 100%;
  margin-right: 2px;
  position: relative;
  top: 1px;
}

.tomb_page .list-item .bottom-line {
  width: 100%;
  height: 1px;
  margin: 0 auto;
  background-color: #f2f2f2;
  margin-bottom: 1.227rem;
  margin-top: 0.72rem;
  transform: translateY(0.5);
  -webkit-transform: translateY(0.5);
  transform-origin: 0 0;
  -webkit-transform-origin: 0 0;
}

.tomb_page .list-item .bottom-flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 2.727rem;
  box-sizing: border-box;
}
.flex-item1 {
  display: flex;
  flex-direction: column;

  align-items: end;
}

.tomb_page .flex-item1 .icon {
  width: 1.91rem;
  height: 1.91rem;
  display: inline-block;
  margin-bottom: 5px;
}

.tomb_page .flex-item1 .icon-del1 {
  background: url(../../../assets/jnt/del.png) no-repeat;
  background-size: 100% 100%;
}

.tomb_page .list-item .bottom-flex .flex-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.tomb_page .list-item .bottom-flex .flex-item .icon {
  width: 1.91rem;
  height: 1.91rem;
  display: inline-block;
  margin-bottom: 5px;
}

.tomb_page .list-item .bottom-flex .flex-item .icon-del1 {
  background: url(../../../assets/jnt/del.png) no-repeat;
  background-size: 100% 100%;
}
.tomb_page .list-item .bottom-flex .flex-item .icon-friends {
  background: url(../../../assets/jnt/qy.png) no-repeat;
  background-size: 100% 100%;
}
.tomb_page .list-item .bottom-flex .flex-item .icon-cancel {
  background: url(../../../assets/jnt/cancel.png) no-repeat;
  background-size: 100% 100%;
}

.tomb_page .list-item .bottom-flex .flex-item .icon-invite {
  background: url(../../../assets/jnt/zf1.png) no-repeat;
  background-size: 100% 100%;
}

.tomb_page .list-item .bottom-flex .flex-item .icon-set {
  background: url(../../../assets/jnt/edit.png) no-repeat;
  background-size: 100% 100%;
}
.tomb_page .list-item .bottom-flex .flex-item .icon-out {
  background: url(../../../assets/jnt/out.png) no-repeat;
  background-size: 100% 100%;
}
.tomb_page .list-item .bottom-flex .flex-item .icon-open1 {
  background: url(../../../assets/jnt/open.png) no-repeat;
  background-size: 100% 100%;
}
.tomb_page .list-item .bottom-flex .flex-item .icon-text {
  font-size: 1.2rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666;
}
.head-topbar {
  display: flex;
  align-items: center;
  height: 3.8rem;
  background: #fff;
  position: fixed;
  width: 100%;
  z-index: 1;
}

.head-topbar.sticky {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 100;
  width: 100%;
}

.head-topbar.fixed {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  width: 100%;
}

.head-topbar .topbar-left {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 6.73333vw;
  position: absolute;
  left: 0.265rem;
  height: 100%;
  z-index: 10;
}

.head-topbar .topbar-left .icon-arrow-left {
  background: url(../../../assets/jnt/left.png) no-repeat;
  background-size: 100%;
  display: inline-block;
  height: 1.363rem;
  width: 0.818rem;
}

.head-topbar .topbar-right .icon-more {
  background: url(../../../assets/jnt/more.png) no-repeat;
  background-size: 100%;
  display: inline-block;
  height: 3.365vw;
  width: 4.125vw;
}

.head-topbar .topbar-main {
  flex: 1;
  color: #333;
  font-size: 1.454rem;
}

.head-topbar .topbar-main,
.head-topbar .topbar-right {
  display: flex;
  justify-content: center;
  align-items: center;
}

.head-topbar .topbar-right {
  padding-right: 1rem;
  position: absolute;
  right: 0.265rem;
  font-size: 1.272rem;
}

.head-topbar .topbar-btn {
  background: #e4803c;
  color: #fff;
  padding: 0.5rem 1.2rem;
  border-radius: 20px;
  font-size: 1.3rem;
}
.adm-infinite-scroll {
  color: var(--adm-color-weak);
  padding: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 13px;
}
</style>
